import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <TopicsSection />
        <CarouselSection />
        <RankingSection />
        <FeaturesSection />
        <FAQSection />
        <MediaSection />
        <ContactSection />
        <UpdatesSection />
        <AppSection />
        <CardsSection />
        <AboutSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}